import React, { useEffect } from 'react';
import { useLocation } from 'wouter';
import ParallaxBackground from '../components/ParallaxBackground';
import Footer from '../components/Footer';
import '../styles/cinematic.css';
import samaarambhLogo from '../assets/team/samaarambh.webp';

const Contact = () => {
    const [_, setLocation] = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const contacts = [
        {
            name: "Suma & Ashish",
            role: "Events",
            phone: "7760362129 | 7759920531",
            email: "saisuma.gudapati24-01@iimv.ac.in | ashish.kullu24-01@iimv.ac.in"
        },
        {
            name: "Gayatri & Neelsagar",
            role: "Sponsorship",
            phone: "7397228552 | 9836006839",
            email: "lakshmigayatri.a24-01@iimv.ac.in neelsagar.sarkar24-01@iimv.ac.in"
        },
        {
            name: "Mansi & Yash",
            role: "PR and Hospitality",
            phone: "7086214015 | 9559901516",
            email: "mansi.agarwalla24-01@iimv.ac.in yash.jaiswal24-01@iimv.ac.in"
        }
    ];

    return (
        <div style={{
            width: '100vw',
            minHeight: '100vh',
            position: 'relative',
            overflowX: 'hidden',
            fontFamily: "'Rajdhani', sans-serif",
            color: '#fff'
        }}>
            {/* Reusing the Cinematic Background */}
            <ParallaxBackground />

            {/* Content Wrapper */}
            <div style={{
                position: 'relative',
                zIndex: 10,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                paddingTop: '90px',
                paddingBottom: '20px'
            }}>
                {/* Logo Section */}
                <div style={{ marginBottom: '40px', textAlign: 'center' }}>
                    <img
                        src={samaarambhLogo}
                        alt="Samaarambh Logo"
                        style={{
                            maxWidth: '700px',
                            width: '90%',
                            filter: 'drop-shadow(0 0 20px rgba(0, 245, 255, 0.6))',
                            animation: 'float 6s ease-in-out infinite'
                        }}
                    />
                </div>

                {/* Email Section */}
                <div style={{
                    marginBottom: '40px',
                    textAlign: 'center',
                    background: 'rgba(0, 0, 0, 0.6)',
                    padding: '20px 40px',
                    borderRadius: '50px',
                    border: '1px solid #FF0095',
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 0 30px rgba(255, 0, 149, 0.2)'
                }}>
                    <h2 style={{
                        fontFamily: 'Orbitron',
                        fontSize: '1.5rem',
                        letterSpacing: '2px',
                        margin: 0,
                        color: '#fff'
                    }}>
                        Write us to : <span className="neon-text-blue" style={{ textDecoration: 'underline' }}>culturalsecy@iimv.ac.in</span>
                    </h2>
                </div>

                {/* Contact Cards Grid */}
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    gap: '30px',
                    maxWidth: '1200px',
                    padding: '0 20px'
                }}>
                    {contacts.map((contact, index) => (
                        <div key={index} className="glass-card" style={{
                            width: '300px',
                            background: 'rgba(255, 255, 255, 0.05)',
                            backdropFilter: 'blur(10px)',
                            border: '1px solid rgba(0, 245, 255, 0.3)',
                            borderRadius: '20px',
                            padding: '30px',
                            textAlign: 'center',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                            cursor: 'default'
                        }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-10px)';
                                e.currentTarget.style.boxShadow = '0 0 30px rgba(0, 245, 255, 0.4)';
                                e.currentTarget.style.border = '1px solid rgba(0, 245, 255, 0.8)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                                e.currentTarget.style.border = '1px solid rgba(0, 245, 255, 0.3)';
                            }}
                        >
                            <h2 style={{ fontFamily: 'Orbitron', marginBottom: '10px', color: '#00F5FF' }}>{contact.name}</h2>
                            <h3 style={{ fontFamily: 'Orbitron', marginBottom: '10px', color: '#00F5FF' }}>{contact.role}</h3>
                            {/* Role removed as per request */}
                            <div style={{ height: '1px', background: 'rgba(255,255,255,0.2)', margin: '15px 0' }} />
                            <p style={{ fontSize: '1.5rem', marginBottom: '5px' }}>{contact.phone}</p>
                            <p style={{ fontSize: '1.1rem', color: '#FF0095' }}>{contact.email}</p>
                        </div>
                    ))}
                </div>


            </div>

            <style>{`
                @keyframes float {
                    0% { transform: translateY(0px); }
                    50% { transform: translateY(-15px); }
                    100% { transform: translateY(0px); }
                }

                @media (max-width: 768px) {
                    .glass-card {
                        width: 100% !important;
                        margin-bottom: 20px;
                    }
                }
            `}</style>
            <Footer />
        </div>
    );
};

export default Contact;
